import { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import Select from "react-dropdown-select";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoginImage from "../../assets/images/login-img.jpg";
import Logo from "../../assets/images/myfx-logo.png";
import { OutletInterface } from "../../assets/interfaces/FX_POS_Interfaces";
import { GetListCommonCall } from "../../POS/APIServices/POS_API_Services";
import { storeClientId, storeMeDetails, storeMenuList, storeSelectedOutlet } from "../../Redux/action";
import WebService from "../../Services/WebService";
import "./LoginComponent.scss";
import { getMenuPermissions } from "../../Services/FXAPIServices";
import { useFeaturePermission } from "../../FeaturePermissions/FeaturePermissionContext";
import { saveFcmToken } from "../../firebase";

const SelectOutlet = () => {
    const { loadFeatures } = useFeaturePermission();
    let dispatch = useDispatch();
    const { outletList } = useLocation().state || { outletList: [] };
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [storedSelectedOutlet, setStoredSelectedOutlet] = useState<OutletInterface[]>([]);
    const [selectedOutlet, setSelectedOutlet] = useState<OutletInterface[]>(storedSelectedOutlet || []);
    const handleOutletChange = (value: OutletInterface[]) => {
        setSelectedOutlet(value);
        setLoading(true);
        localStorage.setItem('outlet_id', value[0]?.id);
        dispatch(storeSelectedOutlet(value));
        meCall();
    }
    useEffect(() => {
        if (outletList.length <= 0) {
            setTimeout(() => {
                navigate('/login');
            }, 2000);
            toast.error('No oulets available,redirecting to login', { autoClose: 1000 });
        }
    }, [outletList]);
    const meCall = () => {
        WebService.getAPI({
            action: 'staffs/me',
            body: null,
            btnId: 'login-button',
            isShowError: true
        }).then((res: any) => {
            dispatch(storeClientId(res.data.client_id));
            dispatch(storeMeDetails(res.data))
            localStorage.setItem('client_id', res.data.client_id);
            getPermissions();
            const currentFcmToken = localStorage.getItem('fcm_token');
            console.log('Current FCM Token:', currentFcmToken);
            if (currentFcmToken) {
                saveFcmToken(currentFcmToken);
            }
        }).catch((error: any) => {
            toast.error(error.response.data.message);
        });
    }

    const getPermissions = () => {
        getMenuPermissions().then((res: any) => {
            getMenus();
            loadFeatures(res?.data || []);
            return res?.data;
        }).catch((error: any) => {
            getMenus();
        });
    }
    const getMenus = () => {
        GetListCommonCall("staffs/my-menus", {}, 'login-button')
            .then((res: any) => {
                setLoading(false);
                if (res.data.length > 0 && res.data.find((item: any) => item.is_enabled && item.subMenus.length > 0)) {
                    dispatch(storeMenuList(res.data))
                    if (res.data.find((item: any) => item.is_enabled && item.code === 'POS')) {
                        let url = res.data.find((item: any) => item.code === 'POS').subMenus[0].url;
                        navigate('/pos' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'INVENTORY')) {
                        let url = res.data.find((item: any) => item.code === 'INVENTORY').subMenus[0].url;
                        navigate('/inventory' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'STAFFING')) {
                        let url = res.data.find((item: any) => item.code === 'STAFFING').subMenus[0].url;
                        navigate('/staffing' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'CRM')) {
                        let url = res.data.find((item: any) => item.code === 'CRM').subMenus[0].url;
                        navigate('/crm' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'RESTAURANT_ADMIN')) {
                        let url = res.data.find((item: any) => item.code === 'RESTAURANT_ADMIN').subMenus[0].url;
                        navigate('/restaurant-admin' + url);
                    } else {
                        let url = res.data.find((item: any) => item.is_enabled && item.code === 'FINANCE').subMenus[0].url;
                        navigate('/finance' + url);
                    }
                } else {
                    toast.error("No menu permissions assigned for outlet");
                }
            })
            .catch(() => {
                setLoading(false);
            });
    }
    const renderForm = () => {
        return (
            <>
                <Form>
                    <Form.Group className="mb-3 custom-form-group">
                        <Form.Label className="font-12 fw-semibold text-muted mb-2">Select Outlet</Form.Label>
                        <Select
                            options={outletList}
                            values={selectedOutlet}
                            valueField="id"
                            loading={loading}
                            searchable
                            searchBy="outlet_name"
                            labelField="outlet_name"
                            onChange={(value: any) => {
                                handleOutletChange(value);
                            }}
                            placeholder="Choose your outlet"
                            itemRenderer={({ item, methods }: any) => (
                                <div
                                    onClick={() => item.has_active_subscription && methods.addItem(item)}
                                    className={`outlet-select-item ${item.has_active_subscription ? "active-sub" : "no-sub"}`}
                                >
                                    <span className="outlet-name-text">{item.outlet_name}</span>
                                    {!item.has_active_subscription && (
                                        <span className="no-sub-badge ms-2">No Active Subscription</span>
                                    )}
                                </div>
                            )}
                        />
                    </Form.Group>
                </Form>
            </>
        );
    };

    return (
        <>
            <div className="login-page">
                <Container fluid className="p-0">
                    <Row className="mx-0 gx-0">
                        <Col className="d-none d-lg-flex position-relative overflow-hidden hero-section">
                            <div className="hero-overlay"></div>
                            <img src={LoginImage} className="login-img" alt="Login Banner" />
                            <div className="hero-content">
                                <span className="brand-badge px-3 py-2 rounded-pill font-12 fw-semibold">Falchion Xenia</span>
                                <div className="hero-footer mb-5">
                                    <h2 className="display-5 font-bold mb-3 heading-animated text-white">Crafting Exceptional Culinary Operations</h2>
                                    <p className="lead opacity-80 body-animated text-white">Streamline your POS, menu management, and inventory tracking with intelligence.</p>
                                    <div className="decor-line"></div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={5} className="form-section">
                            <div className="max-width-form px-4 px-md-5">
                                <div className="login-card-wrapper">
                                    <div className="mb-4 text-center logo-wrapper">
                                        <img
                                            className="logo-img cursor-pointer"
                                            onClick={() => navigate("/login")}
                                            src={Logo}
                                            alt="Logo"
                                        />
                                    </div>
                                    <div className="form-header-text text-center mb-4">
                                        <h4 className="font-bold font-24 mb-2">Select Outlet</h4>
                                        <p className="text-secondary font-15">Choose an outlet to access the portal</p>
                                    </div>
                                    {renderForm()}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default SelectOutlet;
